// Session Storage Keys
export const PGR_CITIZEN_CREATE_COMPLAINT = "PGR_CITIZEN_CREATE_COMPLAINT";
export const PGR_CITIZEN_COMPLAINT_CONFIG = "PGR_CITIZEN_COMPLAINT_CONFIG";
